module.exports = __webpack_public_path__ + "img/r_limg.eb96a55f.png";